module.exports = __webpack_public_path__ + "img/Technology_BG.24054e97.svg";